import React, { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import Icon from '../../../components/AppIcon';

const RealtimeUpdates = ({ userId }) => {
  const [updates, setUpdates] = useState([]);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!userId || !supabase) return;

    setConnected(true);

    const channel = supabase
      ?.channel('analytics_realtime')
      ?.on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'funnel_leads', filter: `user_id=eq.${userId}` }, (payload) => {
        const lead = payload?.new;
        const name = `${lead?.first_name || ''} ${lead?.last_name || ''}`?.trim() || lead?.email || 'Unknown';
        setUpdates(prev => [{
          id: Date.now(),
          type: 'lead',
          message: `New lead added: ${name}`,
          time: new Date()?.toLocaleTimeString()
        }, ...prev?.slice(0, 19)]);
      })
      ?.on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'communication_campaigns', filter: `user_id=eq.${userId}` }, (payload) => {
        setUpdates(prev => [{
          id: Date.now(),
          type: 'campaign',
          message: `New campaign created: ${payload?.new?.name || 'Campaign'}`,
          time: new Date()?.toLocaleTimeString()
        }, ...prev?.slice(0, 19)]);
      })
      ?.subscribe();

    return () => {
      supabase?.removeChannel(channel);
      setConnected(false);
    };
  }, [userId]);

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Real-time Updates</h3>
        <div className="flex items-center space-x-2">
          <div className={`w-2 h-2 rounded-full ${connected ? 'bg-success animate-pulse' : 'bg-muted'}`} />
          <span className="text-xs text-muted-foreground">{connected ? 'Live' : 'Disconnected'}</span>
        </div>
      </div>
      {updates?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">Waiting for real-time updates...</p>
          <p className="text-xs text-muted-foreground mt-2">New leads and campaigns will appear here instantly</p>
        </div>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {updates?.map(update => (
            <div key={update?.id} className="flex items-start space-x-3 p-3 bg-muted/30 rounded-lg">
              <Icon name={update?.type === 'lead' ? 'UserPlus' : 'Send'} size={16} className="text-primary mt-0.5" />
              <div className="flex-1">
                <p className="text-sm text-foreground">{update?.message}</p>
                <p className="text-xs text-muted-foreground">{update?.time}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RealtimeUpdates;